import { gql } from '@apollo/client';

const GET_MAC = gql`
    query getMac($SerialNumber: String, $UDID: String) {
        configProfiles {
            PayloadDisplayName
            PayloadDescription
            PayloadOrganization
            PayloadIdentifier
            PayloadUUID
            MobileConfigData
        }
        mac(SerialNumber: $SerialNumber, UDID: $UDID) {
            SerialNumber
            ProductName
            OSVersion
            UDID
            mdmProfileInstalled
            hasBootstrapToken
            assetTag
            assignedDirectoryUser {
                _id
                name
                firstName
                lastName
                username
                role
                className
                classes
                managedAppleId
                asmUserId
            }
            location {
                _id
                name
                schoolNumber
            }
            unlockPins {
                pin
            }
            QueryResponses {
                AvailableDeviceCapacity
                BluetoothMAC
                BuildVersion
                DeviceCapacity
                DeviceName
                EthernetMAC
                HostName
                IsActivationLockEnabled
                IsAppleSilicon
                IsSupervised
                LocalHostName
                Model
                ModelName
                ModelNumber
                OSUpdateSettings {
                    AutoCheckEnabled
                    AutomaticAppInstallationEnabled
                    AutomaticOSInstallationEnabled
                    AutomaticSecurityUpdatesEnabled
                    BackgroundDownloadEnabled
                }
                OSVersion
                ProductName
                SerialNumber
                SystemIntegrityProtectionEnabled
                UDID
                WiFiMAC
            }
            SecurityInfo {
                FDE_Enabled
                FDE_HasInstitutionalRecoveryKey
                FDE_HasPersonalRecoveryKey
                AllowSigned
                AllowSignedApp
                BlockAllIncoming
                FirewallEnabled
                LoggingEnabled
                LoggingOption
                StealthMode
                IsRecoveryLockEnabled
                EnrolledViaDEP
                IsActivationLockManageable
                IsUserEnrollment
                UserApprovedEnrollment
                RemoteDesktopEnabled
                ExternalBootLevel
                SecureBootLevel
                WindowsBootLevel
            }
            LocalUsers {
              UserName
              FullName
              UID
              UserGUID
              IsLoggedIn
              MobileAccount
              HasSecureToken
            }
            LocalUsersUpdatedAt
            Applications {
              Identifier
              Name
              Version
            }
            disabledProfiles {
                PayloadIdentifier
                PayloadDisplayName
                disabledAt
            }
            assignedSettingsProfiles {
                profileId
                PayloadDisplayName
                PayloadIdentifier
                PayloadUUID
                PayloadDescription
                PayloadOrganization
                PayloadType
                kind
                source
                groupName
                hasInstallablePayload
            }
            assignedDeviceGroups {
                groupId
                groupName
            }
            enrollmentContext {
                hasDepAssignment
                depProfileUuid
                depProfileName
                depIsSupervised
            }
            Profiles {
                HasRemovalPasscode
                IsEncrypted
                IsManaged
                PayloadDescription
                PayloadDisplayName
                PayloadIdentifier
                PayloadOrganization
                PayloadType
                PayloadUUID
                PayloadVersion
                PayloadRemovalDisallowed
                PayloadContent {
                    PayloadDescription
                    PayloadDisplayName
                    PayloadIdentifier
                    PayloadOrganization
                    PayloadType
                    PayloadUUID
                    PayloadVersion
                }
              }
            CertificateList {
                CommonName
                IsIdentity
            }
            AvailableSoftwareUpdates {
                AllowsInstallLater
                Build
                HumanReadableName
                HumanReadableNameLocale
                IsConfigDataUpdate
                IsCritical
                IsFirmwareUpdate
                IsSecurityResponse
                ProductKey
                RequiresBootstrapToken
                RestartRequired
                SupplementalBuildVersion
                Version
            }
            AvailableSoftwareUpdates {
                AllowsInstallLater
                Build
                DownloadSize
                InstallSize
                HumanReadableName
                HumanReadableNameLocale
                IsConfigDataUpdate
                IsCritical
                IsFirmwareUpdate
                IsSecurityResponse
                ProductKey
                ProductName
                RequiresBootstrapToken
                RestartRequired
                SupplementalBuildVersion
                Version
            }
            OSUpdateStatus {
                ProductKey
                Status
                DownloadPercentComplete
                IsDownloaded
            }
            OSUpdateResults {
                InstallAction
                ProductKey
                Status
                ErrorChain {
                    ErrorCode
                    ErrorDomain
                    LocalizedDescription
                    USEnglishDescription
                }
            }
            lastCheckedIn
            lastDdmStatusReportAt
            updatedAt
            bluetoothEnabled
            activationLockBypassCode {
                code
                retrievedAt
            }
        }
    }
`

export { GET_MAC };
